import About from "./Components/About";
import CustomCursor from "./Components/CustomCursor";
import Experience from "./Components/Experience";
import Navbar from "./Components/Navbar";
import Portfolio from "./Components/Portfolio";
import TorchLight from "./Components/TorchLight";


function App() {
  return (
    <div className="h-screen w-screen flex flex-col lg:flex-row">
      <TorchLight />
      <CustomCursor />
      <div className="flex lg:w-[45%] md:w-[100%] ">
        <Navbar />
      </div>
      <div id="scroll-container" className="flex flex-col lg:w-[55%] h-full lg:overflow-y-scroll scroll-smooth">
        <About />
        <Experience />
        <Portfolio />
      </div>
    </div>
  );
}

export default App;
